/**
 * URL masking map — descriptive internal paths → short opaque codes.
 *
 * When a user (or an internal <Link>) navigates to a descriptive path
 * like "/manager/verify", the router intercepts and rewrites the browser
 * URL to the corresponding short code "/x/mv". The user only ever sees
 * short opaque URLs in the address bar, which makes it much harder for
 * casual visitors to enumerate features.
 *
 * Public paths (marketing, auth entry, legal) stay descriptive on purpose
 * for SEO + shareability. Only authenticated internal routes are masked.
 */

export const MASKED_ROUTES = {
  // Overview
  "/": "/x/dh",                          // Dealer/Manager/CSA landing
  // CSA
  "/csa":                "/x/c0",
  "/csa/shift":          "/x/c1",
  "/csa/attendance":     "/x/c2",
  "/csa/leaves":         "/x/c3",
  "/csa/shortages":      "/x/c4",
  // Manager (aliased under /x/m*)
  "/manager/cashbook":         "/x/m1",
  // /manager/dashboard removed in Brick 4 — redirected to Home.
  "/manager/verify":           "/x/m3",
  "/manager/hisabs":           "/x/m4",
  "/manager/day-close":        "/x/m5",
  "/manager/live-board":       "/x/m6",
  "/manager/shift-overrides":  "/x/m7",
  "/manager/attendance":       "/x/m8",
  "/manager/nozzle-verify":    "/x/ma",
  "/manager/bank-deposits":    "/x/mb",
  "/manager/ledgers":          "/x/mc",
  "/manager/shortage":         "/x/md",
  "/manager/my-attendance":    "/x/me",
  // Dealer (aliased under /x/d*)
  "/dealer/registers":         "/x/d1",
  "/dealer/invites":           "/x/d2",
  "/dealer/credit-customers":  "/x/d3",
  "/dealer/dispensers":        "/x/d4",
  "/dealer/data-ops":          "/x/d5",
  "/dealer/rates":             "/x/d6",
  "/dealer/ca-addon":          "/x/d7",
  "/dealer/email-forwarding":  "/x/d8",
  "/dealer/tanks":             "/x/d9",
  "/dealer/alerts":            "/x/da",
  // Cross-role
  "/nozzles/continuity":  "/x/r2",
  "/leave-requests":      "/x/r3",
  "/setup":               "/x/s0",
  "/profile":             "/x/p0",
  "/invite-a-friend":     "/x/iaf",
  // Admin — obfuscated separately (keep /admin/login discoverable for the founder)
  "/admin":               "/x/ac",
};

/** Reverse index for cheap lookups when we need the pretty name (dev only). */
export const REVERSE_MASKED = Object.fromEntries(
  Object.entries(MASKED_ROUTES).map(([k, v]) => [v, k]),
);
